import { render, staticRenderFns } from "./Editor.vue?vue&type=template&id=20f8bd0f&lang=pug&"
import script from "./Editor.vue?vue&type=script&lang=js&"
export * from "./Editor.vue?vue&type=script&lang=js&"
import style0 from "./Editor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20f8bd0f')) {
      api.createRecord('20f8bd0f', component.options)
    } else {
      api.reload('20f8bd0f', component.options)
    }
    module.hot.accept("./Editor.vue?vue&type=template&id=20f8bd0f&lang=pug&", function () {
      api.rerender('20f8bd0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editor/Editor.vue"
export default component.exports